/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #363a3c;
  
  padding-top: 100px;
  margin-bottom: 100px;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HeaderText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 38px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const CssHeaderText100 = css`
  font-weight: 100;
`;
const CssHeaderText300 = css`
  font-weight: 300;
`;
const CssHeaderText400 = css`
  font-weight: 400;
`;

class SectionGreeting extends Component {
  render() {
    return (
      <div className="SectionGreeting" id="SectionOne">

        <Section className="section">
          <ContainerFluid className="container-fluid">
            <HeaderText className="header-text">
              <span className="header-text-700">인사말</span>
            </HeaderText>
            <div>
              <p className="header-text-300" css={CssHeaderText300}>주식회사 봄시스템즈 홈페이지에 방문해 주신 고객여러분 감사합니다.</p>
              <span className="header-text-300" css={CssHeaderText300}>봄시스템즈는 2011년 설립이후 고객들의 다양한 요구사항에 발맞추어 제품과 서비스를 다변화하며 함께 성장하고 있습니다.</span>
              <br/>
              <span className="header-text-300" css={CssHeaderText300}>앞으로도, 고객사의 눈과 귀가 되어 고객보다 먼저 고객의 필요를 생각하고, 최적의 솔루션을 제시하는데 최선의 노력을 기울이겠습니다.</span>
              <p>감사합니다.</p>
            </div>
          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default SectionGreeting;
